<template>
  <div>
    <div class="row">
      <span class="titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12">
        Observações gerais salvas1
      </span>
    </div>
    <div class="row">
      <table
        class="col-md-12"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <tr>
            <th
              class="text-left"
              width="5%"
            >Seq.</th>
            <th
              class="text-left"
              width="10%"
            >Data</th>
            <th
              class="text-left"
              width="70%"
            >Descrição</th>
            <th
              class="text-left"
              width="15%"
            >Tela de origem</th>
            <th
              class="text-left"
              width="10%"
            >Situação</th>
          </tr>
        </thead>
        <tbody>
        <tr v-show="arrayObservacaoProcesso.length == 0">
          <td
            class="text-center"
            colspan="50"
            >{{msgNenhumRegistroEncontrado()}}</td>
          </tr>
          <tr
            v-for="obs in arrayObservacaoProcesso"
            v-bind:key="obs.codObservacao"
          >
            <td class="text-left">
              {{obs.numSequencia}}
            </td>
            <td class="text-left">
              {{ formatarData(obs.datObservacao, 'dd/mm/yyyy') }}
            </td>
            <td class="text-left">
              {{obs.txtObservacao}}
            </td>
            <td class="text-left">
              {{formatarOrigemTela(obs.indOrigemTela)}}
            </td>
            <td class="text-left">
              {{formataStatusProcesso(obs.movimentacaoProcesso.indStatusProcesso)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xs-12">
        <g-timeLine
          id="refTimeLine"
          name="refTimeLine"
          ref="refTimeLine"
          :itens="arrayMovimentacaoProcesso"
          titulo="Etapas Vencidas por Este Processo"
          conteudo="{n}{p}indStatusProcesso{/p} | {p}datMovimentoFormatada{/p} | {p}setor.unidade.orgao.desOrgao{/p} | {p}setor.unidade.desUnidade{/p} | {n}{p}setor.desSetor{/p}"
        >
        </g-timeLine>
      </div>
    </div>
  </div>
</template>
<script>
import GTimeLine from 'components/util/gTimeLine'
import util from 'components/util/util'
import msg from 'components/util/msg'
export default {
  props: {
    paginaStatus: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      arrayObservacaoProcesso: [],
      arrayMovimentacaoProcesso: []
    }
  },
  mounted: function () {
    var paginaStatus = this.paginaStatus
    this.carregarComponente(paginaStatus.arrayObservacaoProcesso, paginaStatus.arrayMovimentacaoProcesso)
  },
  methods: {
    formatarOrigemTela (valor) {
      switch (valor) {
        case 'POR': return 'Solicitação via portal'
        case 'ABE': return 'Abertura'
        case 'MOV': return 'Movimentação'
        case 'CNF': return 'Confirmação'
        case 'EST': return 'Estorno'
        case 'CAN': return 'Cancelamento'
        case 'SIT': return 'Alteração da situação'
        case 'OBS': return 'Obervação Geral'
        case 'ANX': return 'Anexar documento'
        case 'ENC': return 'Encerrar'
        case 'ARQ': return 'Arquivar'
        default:
          return 'Abertura'
      }
    },
    formataStatusProcesso (status) {
      if (status === 'ABE') return 'ABERTO'
      else if (status === 'MOV') return 'MOVIMENTADO'
      else if (status === 'ENC') return 'ENCERRADO'
      else if (status === 'ARQ') return 'ARQUIVADO'
      else if (status === 'CAN') return 'CANCELADO'
      else return ''
    },
    formatarData (data, formato) {
      return util.formatarData(data, formato)
    },
    msgNenhumRegistroEncontrado () {
      return msg.m(6)
    },
    carregarComponente (arrayObservacaoProcesso, arrayMovimentacaoProcesso) {
      this.arrayObservacaoProcesso = []
      this.arrayMovimentacaoProcesso = []
      this.$refs['refTimeLine'].limpar()
      if (util.validarCampo(arrayObservacaoProcesso)) {
        this.arrayObservacaoProcesso = arrayObservacaoProcesso.length > 0 ? arrayObservacaoProcesso : []
      }
      if (util.validarCampo(arrayMovimentacaoProcesso)) {
        if (arrayMovimentacaoProcesso.length > 0) {
          arrayMovimentacaoProcesso.forEach(item => {
            item.datMovimentoFormatada = this.formatarData(item.datMovimento, 'dd/mm/yyyy hh:mm')
          })
          this.arrayMovimentacaoProcesso = arrayMovimentacaoProcesso
        } else {
          this.arrayMovimentacaoProcesso = []
        }
      }
    },
    getObjeto () {
    }
  },
  computed: {},
  watch: {},
  components: { GTimeLine }
}
</script>
